<template>
  <div
    class="modal fade show opacity-100 d-flex align-items-center justify-content-center"
    style="background-color: rgba(0, 0, 0, 0.5)"
    @click="handle_close"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      @click.stop
    >
      <div class="modal-content">
        <div class="modal-body">
            {{ message }}
        </div>

        <div class="modal-footer">
          <button
            v-for="(label, key, index) in buttons"
            :key="key"
            class="btn"
            :class="get_button_class(key, index)"
            type="button"
            @click="handle_close(key)"
          >
            {{ label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fire_event from "@pdfking/workflow/utils/fire_event"
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import keys from "rfuncs/functions/keys"

import close from "../../mixins/close"
import freeze from "../../mixins/freeze"
import keyboard from "../../state/keyboard"

export default {
  mixins: [close, freeze],
  props: {
    id: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    buttons: {
      type: Object,
      required: true
    },
    default_button: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      toggled_class: "modal-body"
    }
  },

  watch: {
    enter_pressed(v) {
      if (v) {
        this.handle_close(this.actual_default_button)
      }
    }
  },

  computed: Object.assign(
    proxy(keyboard, { ENTER: "enter_pressed" }),
    {
      translations: () => make_translations("actions"),
      actual_default_button() {
        // Use provided default_button or default to last button
        const button_keys = keys(this.buttons)
        return this.default_button || button_keys[button_keys.length - 1]
      }
    }
  ),

  methods: {
    get_button_class(key, index) {
      // Style the default button as primary, others as outline
      return key === this.actual_default_button ? 'btn-primary' : 'btn-outline-primary'
    },
    handle_close(button_key = null) {
        // Fire event with the button that was clicked
        fire_event(document, "alert-dialog-result", {
          id: this.id,
          result: button_key
        })
        this.close()
    }
  }
}
</script>
